/**
 * @file formUtil工具
 * @author sunwen(sunwen05@baidu.com)
 */

import _ from 'lodash';

import {DuFormItemControl} from '../../../hooks/biz/form/interface';
import {DISPLAY_ITEM_EXP} from './index';

export function expressionComparison(
    oper: DISPLAY_ITEM_EXP,
    expectedValue: any,
    realValue: any,
    customMethod?: (expectedValue: any, realValue: any) => boolean
): boolean {
    switch (oper) {
        case 'in':
            if (_.isArray(realValue)) {
                let res = true;
                _.each(realValue, item => {
                    if (_.indexOf(expectedValue, item) === -1) {
                        res = false;
                        return false;
                    }
                });
                return res;
            }
            return _.indexOf(expectedValue, realValue) !== -1;
        case 'not-in':
            if (_.isArray(realValue)) {
                let res = true;
                _.each(realValue, item => {
                    if (_.indexOf(expectedValue, item) !== -1) {
                        res = false;
                        return false;
                    }
                });
                return res;
            }
            return _.indexOf(expectedValue, realValue) === -1;
        case '===':
            if (_.isArray(realValue) && _.isArray(expectedValue)) {
                if (expectedValue.length === realValue.length) {
                    return expressionComparison('in', expectedValue, realValue);
                }
                return false;
            }
            return expectedValue === realValue;
        case '!==':
            if (_.isArray(realValue) && _.isArray(expectedValue)) {
                if (expectedValue.length === realValue.length) {
                    return expressionComparison('not-in', expectedValue, realValue);
                }
                return true;
            }
            return expectedValue !== realValue;
        case '>':
            return realValue > expectedValue;
        case '<':
            return realValue < expectedValue;
        case '>=':
            return realValue >= expectedValue;
        case '<=':
            return realValue <= expectedValue;
        case 'custom':
            return customMethod ? customMethod(expectedValue, realValue) : false;
    }
}

export function getValuePropName(control: DuFormItemControl) {
    const {type, config = {}} = control;
    const isCheckbox = type === 'checkbox' && !(config as any).options;
    const isSwitch = type === 'switch';
    return isCheckbox || isSwitch ? 'checked' : 'value';
}